module.exports = __webpack_public_path__ + "img/business_21.c84883bd.jpg";